import { useState } from 'react'
import { router } from '@inertiajs/react'

import { Alert, TextInput } from '@atoms'
import type { TextInputProps } from '@atoms/form/TextInput'
import { FormDialog } from '@components/molecules/FormDialog'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('views.calling_sessions.new')

type CreateCallingSessionDialogProps = {
  callListName: string
  href: string
  defaultName: string
  onClose: () => void
}

export function CreateCallingSessionDialog({
  callListName,
  href,
  defaultName,
  onClose,
}: CreateCallingSessionDialogProps) {
  const [name, setName] = useState(defaultName)
  const [busy, setBusy] = useState(false)
  const [errors, setErrors] = useState<Record<string, string>>({})
  const { name: nameError, ...otherErrors } = errors
  const fieldErrors: TextInputProps['errors'] = nameError ? { name: { type: 'server', message: nameError } } : {}

  const submit = (event: React.FormEvent) => {
    event.preventDefault()
    router.post(
      href,
      { calling_session: { name } },
      {
        preserveScroll: 'errors',
        onStart: () => setBusy(true),
        onFinish: () => setBusy(false),
        onError: setErrors,
      }
    )
  }

  return (
    <FormDialog.Root open onOpenChange={(open) => !open && onClose()} size="lg">
      <FormDialog.Title>{t('title')}</FormDialog.Title>
      <FormDialog.Form onSubmit={submit}>
        <FormDialog.Body>
          {Object.values(otherErrors).map((message) => (
            <Alert key={message} type="error" role="alert">
              {message}
            </Alert>
          ))}
          <p>{t('description', { call_list_name: callListName })}</p>
          <TextInput
            name="name"
            label={t('labels.name')}
            required
            errors={fieldErrors}
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </FormDialog.Body>
        <FormDialog.Footer submitText={t('submit')} isLoading={busy} />
      </FormDialog.Form>
    </FormDialog.Root>
  )
}
